<script>
import {VueFinalModal} from 'vue-final-modal';

import {useVuelidate} from '@vuelidate/core'
import {helpers, required} from '@vuelidate/validators'
import dropZone2Component from "@/components/subcomponents/dropZone2Component.vue";

export default {
  inject: ['$axios', '$_', '$apiBaseURL', '$appVer', '$DateTime'],
  emits: ["cancel", "save"],
  props: {
    title: String,
    formFor: String,
    currentTableData: Array,
    currentTableConfig: Object,
    tableRef: String,
    invoiceTableData: Object,
  },
  name: "vueFinalModal",
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      exportData: {tableProps: true, scopeDetails: true, dataScope: '', fileType: '', exportScope: ''},
      invoice: {number: '', date: '', amount: '', currency: '', file: '', dropzone2Trigger: ''},
      signedInvoice: {file: '', dropzone2Trigger: ''},
      remittanceAdvice: {ref: '', date: '', amount: '', currency: '', file: '', dropzone2Trigger: ''},
      receipt: {number: '', date: '', amount: '', currency: '', file: '', usdrate: '', dropzone2Trigger: ''},
      invoiceFileUploaded: false,
      signedInvoiceFileUploaded: false,
      remittanceFileUploaded: false,
      receiptFileUploaded: false,
    }
  },
  validations() {
    let vm = this;
    let validationObj = {};
    switch (vm.formFor) {
      case 'tableExports':
        break;
      case 'attachingPartnerInvoice':
        validationObj = {
          invoice: {
            number: {required: helpers.withMessage("Please insert Invoice Number", required)},
            date: {required: helpers.withMessage("Please insert Invoice Date", required)},
            amount: {required: helpers.withMessage("Please insert Invoice Amount", required)},
            currency: {required: helpers.withMessage("Please insert Invoice Currency", required)},
          }
        };
        break;
      case 'attachingAmhInvoice':
        validationObj = {
          signedInvoice: {
            file: {required: helpers.withMessage("Please attach the signed Invoice", required)},
          }
        };
        break;
      case 'attachingRemittance':
        validationObj = {
          remittanceAdvice: {
            ref: {required: helpers.withMessage("Please provide the remittance reference", required)},
            date: {required: helpers.withMessage("Please provide the remittance date", required)},
            amount: {required: helpers.withMessage("Please provide the remittance amount", required)},
            currency: {required: helpers.withMessage("Please select the remittance currency", required)},
            file: {required: helpers.withMessage("Please attach the remittance advice", required)},
          }
        };
        break;
      case 'attachingReceipt':
        validationObj = {
          receipt: {
            number: {required: helpers.withMessage("Please provide the receipt number", required)},
            date: {required: helpers.withMessage("Please provide the receipt date", required)},
            amount: {required: helpers.withMessage("Please provide the receipt amount", required)},
            currency: {required: helpers.withMessage("Please select the receipt currency", required)},
            file: {required: helpers.withMessage("Please attach the receipt document", required)},
            usdrate: {required: helpers.withMessage("Please provide the current USD exchange rate", required)},
          }
        };
        break;
    }
    return validationObj;
  },
  components: {
    VueFinalModal,
    dropZone2Component
  },
  computed: {
    setDatePickerClassInvoiceDate: function () {
      let vm = this;
      try {
        if (vm.v$.invoice.date.$errors.length > 0) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    setDatePickerClassRemitanceDate: function () {
      let vm = this;
      try {
        if (vm.v$.remittanceAdvice.date.$errors.length > 0) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    setDatePickerClassReceiptDate: function () {
      let vm = this;
      try {
        if (vm.v$.receipt.date.$errors.length > 0) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    invoiceDateConstrain: function () {
      let vm = this;
      if (typeof vm.currentData.country_tz !== 'undefined') {
        return {
          from: vm.$DateTime.local().setZone(vm.currentData.country_tz).toJSDate()
        }
      } else {
        return {
          from: vm.$DateTime.local().toJSDate()
        };
      }
    },
    invoiceSaveBtnActive: function () {
      let vm = this;

      return !(vm.v$.$errors.length > 0);
    },
    signedInvoiceSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0 || !vm.signedInvoiceFileUploaded);
    },
    remittanceSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0 || !vm.remittanceFileUploaded);
    },
    receiptSaveBtnActive: function () {
      let vm = this;
      return !(vm.v$.$errors.length > 0 || !vm.receiptFileUploaded);
    }
  },
  methods: {
    uploadInProgress: function (uploadInProgressEmission) {
      let vm = this;
      switch (vm.formFor) {
        case 'tableExports':
          break;
        case 'attachingPartnerInvoice':
          vm.invoiceFileUploaded = uploadInProgressEmission.uploadDone;
          break;
        case 'attachingAmhInvoice':
          vm.signedInvoiceFileUploaded = uploadInProgressEmission.uploadDone;
          break;
        case 'amhRemittanceAtachment':
          vm.remittanceFileUploaded = uploadInProgressEmission.uploadDone;
          break;
      }
    },
    dropZone2Emissions: function (dropZone2Emission) {
      let vm = this;

      switch (vm.formFor) {
        case 'tableExports':
          break;
        case 'attachingPartnerInvoice':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.invoice.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.invoice.file = '';
          }
          vm.invoiceFileUploaded = true;
          break;
        case 'attachingAmhInvoice':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.signedInvoice.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.signedInvoice.file = '';
          }
          vm.signedInvoiceFileUploaded = true;
          break;
        case 'attachingRemittance':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.remittanceAdvice.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.remittanceAdvice.file = '';
          }
          vm.remittanceFileUploaded = true;
          break;
        case 'attachingReceipt':
          if (dropZone2Emission.action === 'imageAdded') {
            vm.receipt.file = dropZone2Emission.fileDetails;
          }
          if (dropZone2Emission.action === 'imageRemoved') {
            vm.receipt.file = '';
          }
          vm.receiptFileUploaded = true;
          break;
      }

    },
    invoiceDateSelected: function () {
    },
    remittanceDateSelected: function () {
    },
    decimalNumbersAllowed: function (event) {
      let charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 8 || charCode === 127 || charCode === 190) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    closeModal: function () {
      let vm = this;
      vm.$emit('cancel', {});
    },
    processExport: function () {
      let vm = this;

      vm.validateForm();

    },
    savePartnerInvoiceData: function () {
      let vm = this;
      try {
        if (vm.invoiceSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/report/action/insertPartnerInvoice', {
                  repData: vm.currentData,
                  invoiceData: vm.invoice,
                  formFor: vm.formFor,
                  invoiceTableData: vm.invoiceTableData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  if (response.data.success) {
                    vm.$emit('save', {});
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveSignedAmhInvoiceData: function () {
      let vm = this;
      try {
        if (vm.signedInvoiceSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/report/action/insertSignedAmhInvoice', {
                  repData: vm.currentData,
                  signedInvoice: vm.signedInvoice,
                  formFor: vm.formFor,
                  invoiceTableData: vm.invoiceTableData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  if (response.data.success) {
                    vm.$emit('save', {});
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveAmhRemittanceData: function () {
      let vm = this;
      try {
        if (vm.remittanceSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/report/action/insertRemittanceAdvice', {
                  repData: vm.currentData,
                  remittanceAdvice: vm.remittanceAdvice,
                  formFor: vm.formFor,
                  invoiceTableData: vm.invoiceTableData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  if (response.data.success) {
                    vm.$emit('save', {});
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    saveReceiptData: function () {
      let vm = this;
      try {
        if (vm.receiptSaveBtnActive) {
          vm.validateForm();
          if (vm.v$.$errors.length === 0) {
            vm.$axios
                .post('/report/action/insertReceiptData', {
                  repData: vm.currentData,
                  receipt: vm.receipt,
                  formFor: vm.formFor,
                  invoiceTableData: vm.invoiceTableData,
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${vm.currentData.token}`
                  }
                })
                .then(function (response) {
                  if (response.data.success) {
                    vm.$emit('save', {});
                  }
                });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    toggleExportPrefs: function (checkName) {
      let vm = this;
      switch (checkName) {
        case 'tableProps':
          vm.exportData.tableProps = !vm.exportData.tableProps;
          break
        case 'scopeDetails':
          vm.exportData.scopeDetails = !vm.exportData.scopeDetails;
          break
      }
    },
    toggleFileType: function (fileType) {
      let vm = this;
      switch (fileType) {
        case 'pdf':
          vm.exportData.fileType = 'fileTypePdf';
          break
        case 'csv':
          vm.exportData.fileType = 'fileTypeCsv';
          break
      }
    },
    toggleScopeType: function (scopeName) {
      let vm = this;
      vm.exportData.exportScope = scopeName
    },
    returnDataTsAndPartnerId: function (caseId, recordyear) {
      let vm = this;
      return `${caseId}_${vm.currentData.partnerid}_${recordyear}`
    },
    returnDataInvoiceAndPartnerId: function (invoiceNumber, recordyear) {
      let vm = this;
      let cleanedInvoiceNumber = invoiceNumber.replace(/ /g, "__");
      cleanedInvoiceNumber = cleanedInvoiceNumber.replace(/\//g, "_");

      return `${cleanedInvoiceNumber}__${vm.invoiceTableData.partnerid}_${recordyear}`
    },
    returnArrayFromCSV: function (csvText) {
      let vm = this;
      return vm.$_.split(csvText, ',');
    },
    async validateForm() {
      const vm = this;
      await this.v$.$validate();
      vm.validationHasOccured = true;
    },

  },
  async mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);
  }
};
</script>

<template>
  <VueFinalModal
      class="confirm-modal"
      content-class="confirm-modal-content"
      overlay-transition="vfm-fade"
      content-transition="vfm-fade"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button class="delete button is-black" aria-label="close" v-on:click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <slot></slot>
        <div v-if="formFor==='tableExports'">
          <div class="columns is-centered is-multiline is-vcentered margin-0">
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="checkbox" id="exportallrecords"
                           value="exportallrecords"
                           class="fancy-input"
                           v-model="exportData.tableProps"
                           v-on:click.prevent/>
                    <label for="exportallrecords" class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleExportPrefs('tableProps')">Use Table Props</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="checkbox" id="exportdetails"
                           value="exportdetails"
                           class="fancy-input"
                           v-model="exportData.scopeDetails"
                           v-on:click.prevent/>
                    <label for="exportdetails" class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleExportPrefs('scopeDetails')">with Details</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <slot name="fileScope"></slot>
          <div class="columns is-centered is-multiline is-vcentered margin-0">
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="radio" name="fileScopeSelect" id="fileScopeSelectAll"
                           value="allRecords"
                           class="fancy-input"
                           v-model="exportData.exportScope"
                           v-on:click.prevent/>
                    <label for="fileScopeSelectAll"
                           class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleScopeType('allRecords')">All Records</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="radio" name="fileScopeSelect" id="fileScopeSelectVisible"
                           value="visibleRecords"
                           class="fancy-input"
                           v-model="exportData.exportScope"
                           v-on:click.prevent/>
                    <label for="fileScopeSelectVisible"
                           class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleScopeType('visibleRecords')">Visible Records</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <slot name="fileType"></slot>
          <div class="columns is-centered is-multiline is-vcentered margin-0">
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="radio" name="fileTypeSelect" id="fileTypeSelectPdf"
                           value="fileTypePdf"
                           class="fancy-input"
                           v-model="exportData.fileType"
                           v-on:click.prevent/>
                    <label for="fileTypeSelectPdf" class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleFileType('pdf')">PDF</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-narrow">
              <div class="field is-narrow">
                <div class="control">
                  <div class="fancy-input-group padded-checkboxes">
                    <input type="radio" name="fileTypeSelect" id="fileTypeSelectCsv"
                           value="fileTypeCsv"
                           class="fancy-input"
                           v-model="exportData.fileType"
                           v-on:click.prevent/>
                    <label for="fileTypeSelectCsv" class="fancy-input-label no-wrapping-label margin-5-button z-index-1"
                           v-on:click.stop="toggleFileType('csv')">CSV</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div v-if="formFor==='attachingPartnerInvoice'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Case</div>
                  </div>

                  <div class="column is-one-third has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Patient Name</label>
                    {{ invoiceTableData.p_name }}
                  </div>
                  <div class="column is-one-third has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Case ID</label>
                    {{ invoiceTableData.caseid }}
                  </div>
                  <div class="column is-one-third has-text-left bottom-border-input">
                    <label class="label has-text-centered">SAFE Ask</label>
                    USD {{ invoiceTableData.p_safeaskamount }}
                  </div>

                  <div class="column is-half has-text-left right-border-input bottom-border-input-mobile">
                    <label class="label has-text-centered">Surgery</label>
                    {{ invoiceTableData.p_surgeryrequired }}
                  </div>
                  <div class="column is-half has-text-left">
                    <label class="label has-text-centered">Date</label>
                    {{ invoiceTableData.surgeryperformancedate }}
                  </div>


                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="invoiceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Invoice</div>
                  </div>

                  <div class="column is-half has-text-left right-border-input bottom-border-input">
                    <label class="label has-text-centered">Invoice Number</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <input class="input input-no-top-margin" type="text"
                               placeholder="Invoice Number"
                               v-bind:class="{'error-input':v$.invoice.number.$errors.length>0}"
                               v-model="invoice.number">
                        <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'circle-question']"/>
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="column is-half has-text-left bottom-border-input">
                    <label class="label has-text-centered">Invoice Date</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <datepicker v-model="invoice.date" name="invoiceDate"
                                    v-bind:disabled-dates="invoiceDateConstrain"
                                    v-bind:clear-button="true"
                                    v-bind:input-class="'input-custom'"
                                    v-bind:wrapper-class="setDatePickerClassInvoiceDate"
                                    v-bind:calendar-class="'calendar-custom'"
                                    v-on:selected="invoiceDateSelected">
                        </datepicker>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-left bottom-border-input">
                    <label class="label has-text-centered">Invoice Amount</label>
                    <div class="field has-addons">
                      <p class="control">
                        <span class="select">
                          <select v-model="invoice.currency"
                                  v-bind:class="{'error-input':v$.invoice.currency.$errors.length>0}">
                            <option value="">Select One</option>
                            <option value="USD">USD</option>
                            <option value="KES">KES</option>
                            <option value="UGX">UGX</option>
                            <option value="TSH">TSH</option>
                            <option value="ETB">ETB</option>
                            <option value="MWK">MWK</option>
                          </select>
                        </span>
                      </p>
                      <p class="control is-expanded">
                        <input class="input input-no-margin-top" type="number"
                               placeholder="Invoice Amount"
                               v-bind:class="{'error-input':v$.invoice.amount.$errors.length>0}"
                               v-model.number="invoice.amount"
                               v-on:keydown="decimalNumbersAllowed">
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-left">
                    <label class="label has-text-centered">Invoice File</label>
                    <div class="field">
                      <p class="control is-expanded">
                        <dropZone2Component
                            v-bind:id="`partnerInvoiceFile`"
                            v-bind:key="`partnerInvoiceFile`"
                            v-bind:fileIdentifier="`partnerInvoiceFile`"
                            v-bind:formName="`partnerInvoiceAttachment`"
                            v-bind:zoneTitle="'Invoice File'"
                            v-bind:dataTs="returnDataTsAndPartnerId(invoiceTableData.caseid, invoiceTableData.recordyear)"
                            v-bind:imageDataObj="invoice.file"
                            v-bind:acceptedFiles="'.pdf,.jpg,.jpeg,.png,.doc,.docx'"
                            v-on:dropZone2Emissions="dropZone2Emissions"
                            v-on:uploadInProgress="uploadInProgress"
                        ></dropZone2Component>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingAmhInvoice'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">AMH Invoice</div>
                  </div>
                  <div class="column is-5 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Number</label>
                    {{ invoiceTableData.invoicenumber }}
                  </div>
                  <div class="column is-3 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Amount</label>
                    {{ invoiceTableData.invoiceAmount }}
                  </div>
                  <div class="column is-4 has-text-left bottom-border-input">
                    <label class="label has-text-centered">Pocket</label>
                    {{ invoiceTableData.invoicePocket }}
                  </div>
                  <div class="column is-full">
                    <label class="label has-text-centered">Case IDs</label>
                    <div class="caseid-container">
                      <a v-for="(caseId) in returnArrayFromCSV(invoiceTableData.caseIdList)" v-bind:key="caseId"
                         class="button is-success is-light caseid-button"
                         v-bind:href="'/caseview/'+caseId+'/financecase/'+invoiceTableData.partnerid+'/'+invoiceTableData.recordyear"
                         target="_blank"><span>{{ caseId }}</span>
                        <span class="icon is-small">
                      <i class="fas fa-arrow-up-right-from-square"></i></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="invoiceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full has-text-left">
                    <label class="label has-text-centered">Signed Invoice File</label>
                    <div class="field">
                      <p class="control is-expanded"
                         v-bind:class="{'error-input':v$.signedInvoice.file.$errors.length>0}">
                        <dropZone2Component
                            v-bind:id="`signedAmhInvoiceFile`"
                            v-bind:key="`signedAmhInvoiceFile`"
                            v-bind:fileIdentifier="`signedAmhInvoiceFile`"
                            v-bind:formName="`signedAmhInvoiceAttachment`"
                            v-bind:zoneTitle="'Signed Invoice File'"
                            v-bind:dataTs="returnDataInvoiceAndPartnerId(invoiceTableData.invoicenumber, invoiceTableData.recordyear)"
                            v-bind:imageDataObj="signedInvoice.file"
                            v-bind:acceptedFiles="'.pdf,.jpg,.jpeg,.png,.doc,.docx'"
                            v-on:dropZone2Emissions="dropZone2Emissions"
                            v-on:uploadInProgress="uploadInProgress"
                        ></dropZone2Component>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingRemittance'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">AMH Invoice</div>
                  </div>
                  <div class="column is-5 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Number</label>
                    {{ invoiceTableData.invoicenumber }}
                  </div>
                  <div class="column is-3 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Amount</label>
                    {{ invoiceTableData.invoiceAmount }}
                  </div>
                  <div class="column is-4 has-text-left bottom-border-input">
                    <label class="label has-text-centered">Pocket</label>
                    {{ invoiceTableData.invoicePocket }}
                  </div>
                  <div class="column is-full">
                    <label class="label has-text-centered">Case IDs</label>
                    <div class="caseid-container">
                      <a v-for="(caseId) in returnArrayFromCSV(invoiceTableData.caseIdList)" v-bind:key="caseId"
                         class="button is-success is-light caseid-button"
                         v-bind:href="'/caseview/'+caseId+'/financecase/'+invoiceTableData.partnerid+'/'+invoiceTableData.recordyear"
                         target="_blank"><span>{{ caseId }}</span>
                        <span class="icon is-small">
                      <i class="fas fa-arrow-up-right-from-square"></i></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="remitanceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Remittance Advice</div>
                  </div>

                  <div class="column is-half has-text-left right-border-input bottom-border-input">
                    <label class="label has-text-centered">Remittance Reference</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <input class="input input-no-top-margin" type="text"
                               placeholder="Reference"
                               v-bind:class="{'error-input':v$.remittanceAdvice.ref.$errors.length>0}"
                               v-model="remittanceAdvice.ref">
                        <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'circle-question']"/>
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="column is-half has-text-left bottom-border-input">
                    <label class="label has-text-centered">Remitance Date</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <datepicker v-model="remittanceAdvice.date" name="remittanceDate"
                                    v-bind:disabled-dates="invoiceDateConstrain"
                                    v-bind:clear-button="true"
                                    v-bind:input-class="'input-custom'"
                                    v-bind:wrapper-class="setDatePickerClassRemitanceDate"
                                    v-bind:calendar-class="'calendar-custom'"
                                    v-on:selected="remittanceDateSelected">
                        </datepicker>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-left bottom-border-input">
                    <label class="label has-text-centered">Remitted Amount</label>
                    <div class="field has-addons">
                      <p class="control">
                        <span class="select">
                          <select v-model="remittanceAdvice.currency"
                                  v-bind:class="{'error-input':v$.remittanceAdvice.currency.$errors.length>0}">
                            <option value="">Select One</option>
                            <option value="USD">USD</option>
                            <option value="KES">KES</option>
                            <option value="UGX">UGX</option>
                            <option value="TSH">TSH</option>
                            <option value="ETB">ETB</option>
                            <option value="MWK">MWK</option>
                          </select>
                        </span>
                      </p>
                      <p class="control is-expanded">
                        <input class="input input-no-margin-top" type="number"
                               placeholder="Remittance Amount"
                               v-bind:class="{'error-input':v$.remittanceAdvice.amount.$errors.length>0}"
                               v-model.number="remittanceAdvice.amount"
                               v-on:keydown="decimalNumbersAllowed">
                      </p>
                    </div>
                  </div>


                  <div class="column is-full has-text-left">
                    <div class="field">
                      <p class="control is-expanded"
                         v-bind:class="{'error-input':v$.remittanceAdvice.file.$errors.length>0}">
                        <dropZone2Component
                            v-bind:id="`amhRemittanceFile`"
                            v-bind:key="`amhRemittanceFile`"
                            v-bind:fileIdentifier="`amhRemittanceFile`"
                            v-bind:formName="`amhRemittanceAttachment`"
                            v-bind:zoneTitle="'Remittance Advice'"
                            v-bind:dataTs="returnDataInvoiceAndPartnerId(invoiceTableData.invoicenumber, invoiceTableData.recordyear)"
                            v-bind:imageDataObj="remittanceAdvice.file"
                            v-bind:acceptedFiles="'.pdf,.jpg,.jpeg,.png,.doc,.docx'"
                            v-on:dropZone2Emissions="dropZone2Emissions"
                            v-on:uploadInProgress="uploadInProgress"
                        ></dropZone2Component>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingReceipt'">
          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="caseDetails" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">AMH Remittance</div>
                  </div>
                  <div class="column is-5 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Reference</label>
                    {{ invoiceTableData.remittanceRef }}
                  </div>
                  <div class="column is-3 has-text-left bottom-border-input right-border-input">
                    <label class="label has-text-centered">Amount</label>
                    {{ invoiceTableData.remittanceAmount }}
                  </div>
                  <div class="column is-4 has-text-left bottom-border-input">
                    <label class="label has-text-centered">Pocket</label>
                    {{ invoiceTableData.invoicePocket }}
                  </div>
                  <div class="column is-full">
                    <label class="label has-text-centered">Case IDs</label>
                    <div class="caseid-container">
                      <a v-for="(caseId) in returnArrayFromCSV(invoiceTableData.caseIdList)" v-bind:key="caseId"
                         class="button is-success is-light caseid-button"
                         v-bind:href="'/caseview/'+caseId+'/financecase/'+invoiceTableData.partnerid+'/'+invoiceTableData.recordyear"
                         target="_blank"><span>{{ caseId }}</span>
                        <span class="icon is-small">
                      <i class="fas fa-arrow-up-right-from-square"></i></span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="remitanceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Receipt</div>
                  </div>

                  <div class="column is-half has-text-left right-border-input bottom-border-input">
                    <label class="label has-text-centered">Receipt Number</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <input class="input input-no-top-margin" type="text"
                               placeholder="Reference"
                               v-bind:class="{'error-input':v$.receipt.number.$errors.length>0}"
                               v-model="receipt.number">
                        <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'circle-question']"/>
                        </span>
                      </p>
                    </div>
                  </div>

                  <div class="column is-half has-text-left bottom-border-input">
                    <label class="label has-text-centered">Receipt Date</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <datepicker v-model="receipt.date" name="remittanceDate"
                                    v-bind:disabled-dates="invoiceDateConstrain"
                                    v-bind:clear-button="true"
                                    v-bind:input-class="'input-custom'"
                                    v-bind:wrapper-class="setDatePickerClassReceiptDate"
                                    v-bind:calendar-class="'calendar-custom'"
                                    v-on:selected="remittanceDateSelected">
                        </datepicker>
                      </p>
                    </div>
                  </div>

                  <div class="column is-full has-text-left bottom-border-input">
                    <label class="label has-text-centered">Receipt Amount</label>
                    <div class="field has-addons">
                      <p class="control">
                        <span class="select">
                          <select v-model="receipt.currency"
                                  v-bind:class="{'error-input':v$.receipt.currency.$errors.length>0}">
                            <option value="">Select One</option>
                            <option value="USD">USD</option>
                            <option value="KES">KES</option>
                            <option value="UGX">UGX</option>
                            <option value="TSH">TSH</option>
                            <option value="ETB">ETB</option>
                            <option value="MWK">MWK</option>
                          </select>
                        </span>
                      </p>
                      <p class="control is-expanded">
                        <input class="input input-no-margin-top" type="number"
                               placeholder="Receipt Amount"
                               v-bind:class="{'error-input':v$.receipt.amount.$errors.length>0}"
                               v-model.number="receipt.amount"
                               v-on:keydown="decimalNumbersAllowed">
                      </p>
                    </div>
                  </div>


                  <div class="column is-full has-text-left">
                    <div class="field">
                      <p class="control is-expanded"
                         v-bind:class="{'error-input':v$.receipt.file.$errors.length>0}">
                        <dropZone2Component
                            v-bind:id="`partnerReceiptFile`"
                            v-bind:key="`partnerReceiptFile`"
                            v-bind:fileIdentifier="`partnerReceiptFile`"
                            v-bind:formName="`partnerReceiptAttachment`"
                            v-bind:zoneTitle="'Receipt Document'"
                            v-bind:dataTs="returnDataInvoiceAndPartnerId(invoiceTableData.remittanceRef, invoiceTableData.recordyear)"
                            v-bind:imageDataObj="receipt.file"
                            v-bind:acceptedFiles="'.pdf,.jpg,.jpeg,.png,.doc,.docx'"
                            v-on:dropZone2Emissions="dropZone2Emissions"
                            v-on:uploadInProgress="uploadInProgress"
                        ></dropZone2Component>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="container margin-50-up-down">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <div id="remitanceDetails" class="columns is-multiline is-vcentered section-box">

                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Other Information</div>
                  </div>

                  <div class="column is-full has-text-left bottom-border-input">
                    <label class="label has-text-centered">USD Exchange Rate</label>
                    <div class="field">
                      <p class="control is-expanded has-icons-left">
                        <input class="input input-no-margin-top" type="number"
                               placeholder="USD Rate"
                               v-bind:class="{'error-input':v$.receipt.usdrate.$errors.length>0}"
                               v-model.number="receipt.usdrate"
                               v-on:keydown="decimalNumbersAllowed">
                        <span class="icon is-small is-left">
                          <font-awesome-icon :icon="['fas', 'dollar-sign']"/>
                        </span>
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>


        </div>

      </section>
      <footer class="modal-card-foot">

        <div v-if="formFor==='tableExports'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="processExport">Export</button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingPartnerInvoice'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="savePartnerInvoiceData"
                          v-bind:disabled="!invoiceSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingAmhInvoice'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveSignedAmhInvoiceData"
                          v-bind:disabled="!signedInvoiceSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingRemittance'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveAmhRemittanceData"
                          v-bind:disabled="!remittanceSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="formFor==='attachingReceipt'" class="width-100">
          <div class="columns is-centered is-multiline is-vcentered margin-0 width-100">
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-success is-fullwidth" v-on:click="saveReceiptData"
                          v-bind:disabled="!receiptSaveBtnActive">Save
                  </button>
                </div>
              </div>
            </div>
            <div class="column is-one-quarter">
              <div class="field">
                <div class="control">
                  <button class="button is-fullwidth" v-on:click="closeModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </VueFinalModal>
</template>


<style>
.z-index-1 {
  z-index: 1 !important;
}

.margin-0 {
  margin: 0 !important;
}

.width-100 {
  width: 100% !important;
}

.confirm-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-modal-content {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
}

.confirm-modal-content > * + * {
  margin: 0.5rem 0;
}

.confirm-modal-content h1 {
  font-size: 1.375rem;
}

.confirm-modal-content button {
  margin: 0.25rem 0 0 auto;
  padding: 0 8px;
  border: 1px solid;
  border-radius: 0.5rem;
}

.dark .confirm-modal-content {
  background: #000;
}

.margin-50-up-down {
  margin: 50px 0 !important;
}

.caseid-button {
  margin: 3px !important;
}

.caseid-container {
  max-height: 300px;
  width: 100%;
  overflow: auto;
}
</style>